import React, { useEffect, useRef } from 'react';

export default function ExampleModal({ open, onClose, title, content, language }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (open) dialogRef.current?.showModal?.();
    else dialogRef.current?.close?.();
  }, [open]);

  if (!open) return null;

  return (
    <dialog
      ref={dialogRef}
      className="example-modal-backdrop"
      onClick={(e) => { if (e.target === dialogRef.current) onClose(); }}
    >
      <div className="example-modal">
        <header className="example-modal__head">
          <h3 className="example-modal__title">{title || 'Example Input'}</h3>
          <button type="button" className="example-modal__close" onClick={onClose}>&times;</button>
        </header>
        <pre className="example-modal__code">{content}</pre>
        <footer className="example-modal__foot">
          <button
            type="button"
            className="dm-btn dm-btn--ghost"
            onClick={() => { navigator.clipboard.writeText(content); }}
          >
            Copy to clipboard
          </button>
          <button type="button" className="dm-btn" onClick={onClose}>Close</button>
        </footer>
      </div>
    </dialog>
  );
}
